export default "__VITE_ASSET__z_0mTmju__"